import dayjs from 'dayjs';
import SelectorEngine from '../../utils/dom/selector-engine';
import { padNumber } from '../../utils/misc';

class Countdown {
	constructor() {
		this._wrappers = undefined;
		this.init();
	}

	init() {
		this._wrappers = SelectorEngine.find('.lta-countdown');
		this._wrappers.forEach((wrapper) => {
			const mode = wrapper.dataset.mode;
			if(mode === 'localtime') {
				this.initiateLocalTime(wrapper);
			} else {
				this.initiateCountdown(wrapper);
			}
		});
	}

	initiateCountdown(wrapper) {
		const dialGroups = SelectorEngine.find('.lta-countdown--time-dial', wrapper);
		const { daysDials, hoursDials, minutesDials } = this.getDials(dialGroups);
		const currentTimestamp = Date.now();
		let eventTimestamp = wrapper.dataset.timestamp;

		if(!eventTimestamp) {
			const contdownDate = dayjs(wrapper.dataset.date).toDate();
			eventTimestamp = contdownDate.getTime();
		}

		const one_day = 1000 * 60 * 60 * 24;
		const one_hour = 1000 * 60 * 60;
		const one_minute = 1000 * 60;

		let Difference_In_Time = eventTimestamp - currentTimestamp;

		if(Difference_In_Time > 0 ) {

			const differenceDays = Math.floor(Difference_In_Time / one_day);

			Difference_In_Time = Difference_In_Time - (differenceDays * one_day);
			let differenceHours = Math.floor(Difference_In_Time / one_hour);

			Difference_In_Time = Difference_In_Time - (differenceHours * one_hour);
			let differenceMinutes = Math.floor(Difference_In_Time / one_minute);

			this.setDialsValue(daysDials, padNumber(differenceDays));
			this.setDialsValue(hoursDials, padNumber(differenceHours));
			this.setDialsValue(minutesDials, padNumber(differenceMinutes));

			const countDown = () => {
				if (differenceMinutes > 0 ) {
					this.setDialsValue(minutesDials, padNumber(differenceMinutes - 1));
					differenceMinutes = differenceMinutes -1;
				}
				if (differenceMinutes === 0 && differenceHours > 0) {
					this.setDialsValue(minutesDials, padNumber(59));
					differenceMinutes = 59;
					if (differenceHours > 0) {
						this.setDialsValue(hoursDials, padNumber(differenceHours - 1));
						differenceHours = differenceHours - 1;
					}
					if (differenceHours === 0 && differenceDays > 0) {
						this.setDialsValue(hoursDials, padNumber(59));
						differenceHours = 59;
						this.setDialsValue(daysDials, padNumber(differenceDays - 1));
						differenceHours = differenceDays - 1;

					}
				}
			};
			setInterval(countDown, 60 * 1000);
		}
	}

	initiateLocalTime(wrapper) {
		const dialGroups = SelectorEngine.find('.lta-countdown--time-dial', wrapper);
		const { hoursDials, minutesDials, secondsDials } = this.getDials(dialGroups);
		let todayDate = new Date();
		let hours = todayDate.getHours();
		let minutes = todayDate.getMinutes();
		let seconds = todayDate.getSeconds();
		this.setDialsValue(hoursDials, padNumber(hours));
		this.setDialsValue(minutesDials, padNumber(minutes));
		this.setDialsValue(secondsDials, padNumber(seconds));

		setInterval(() => {
			todayDate = new Date();
			hours = todayDate.getHours();
			minutes = todayDate.getMinutes();
			seconds = todayDate.getSeconds();
			this.setDialsValue(hoursDials, padNumber(hours));
			this.setDialsValue(minutesDials, padNumber(minutes));
			this.setDialsValue(secondsDials, padNumber(seconds));
		}, 1000);
	}

	setDialsValue (dials, value) {
		dials[0].innerHTML = value[0];
		dials[1].innerHTML = value[1];
	}

	getDials(dialGroups) {
		let daysDials = [];
		let hoursDials = [];
		let minutesDials = [];
		let secondsDials = [];
		dialGroups.forEach((group) => {
			if (group.dataset.dial === 'days') {
				daysDials = SelectorEngine.find('.lta-countdown--number', group);
			}
			if (group.dataset.dial === 'hours') {
				hoursDials = SelectorEngine.find('.lta-countdown--number', group);
			}
			if (group.dataset.dial === 'minutes') {
				minutesDials = SelectorEngine.find('.lta-countdown--number', group);
			}
			if (group.dataset.dial === 'seconds') {
				secondsDials = SelectorEngine.find('.lta-countdown--number', group);
			}
		});
		return {daysDials, hoursDials, minutesDials, secondsDials};
	}
}

const globalCountdown = new Countdown();

export default globalCountdown;
